import { render, staticRenderFns } from "./LeftSide.vue?vue&type=template&id=230e0614&"
import script from "./LeftSide.vue?vue&type=script&lang=js&"
export * from "./LeftSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports